import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../../api";

const Contact = () => {
    const { campus_slug } = useParams();
    const [contactData, setContactData] = useState(null);

    useEffect(() => {
        api.get(`/api/campus/${campus_slug}/contact`)
            .then(res => setContactData(res.data))
            .catch(err => console.error(err));
    }, [campus_slug]);
    
    if (!contactData) {
        return <></>;
    }

    if (!contactData.title && !contactData.location && !contactData.email && !contactData.phone && !contactData.map_iframe_src) {
        return <></>;
    }

    const contactInfo = [
        { icon: "location", text: contactData.location },
        { icon: "mail", text: contactData.email },
        { icon: "phone", text: contactData.phone },
    ];

    return (
        <section className="contact_container pt_80 pb_80">
            <div className="container">
                <div className="row d-flex justify-content-center align-items-center">
                    {contactData.title || contactData.location || contactData.email || contactData.phone ? (
                    <div className="col-lg-5 col-md-5 col-12 wow slideInUp mb-3" data-wow-duration="2s">
                        <div className="card contact-card shadow-lg">
                            <div className="contact fw-bold pt_80 p-5">
                                
                                {contactData.title && (
                                <h3 className="fw-bold d-flex justify-content-center align-items-center text-white my-4">
                                    {contactData.title}
                                </h3>
                                )}
                                {contactInfo.filter(item => item.text).map((item, index) => (
                                    <div className="d-flex align-items-start mt-4" key={index}>
                                        <img
                                            src={`/assets/images/${item.icon}.png`}
                                            alt={item.icon}
                                            className="me-3 icon"
                                        />
                                        <div>
                                            <p className="mt-1">{item.text}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    ) : null}
                    {contactData.map_iframe_src && (
                    <div className="col-lg-5 col-md-5 col-12 mb-3 wow slideInUp" data-wow-duration="2s" data-wow-delay="0.2s">
                        <div className="contact p-1">
                            <iframe
                                src={contactData.map_iframe_src}
                                height="320"
                                style={{ width: '100%' }}
                                title="Campus Location"
                                allowFullScreen
                                loading="lazy"
                            ></iframe>
                        </div>
                    </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Contact;